module.exports = __webpack_public_path__ + "c4ca34bc9434be2969680d37ffaef3db.MP3";